import { render } from "./IdeaDetailView.vue?vue&type=template&id=878f3a48&scoped=true&ts=true"
import script from "./IdeaDetailView.vue?vue&type=script&lang=ts"
export * from "./IdeaDetailView.vue?vue&type=script&lang=ts"

import "./IdeaDetailView.vue?vue&type=style&index=0&id=878f3a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878f3a48"]])

export default __exports__